import constants from './masterConstants';

export function uniformGrid(size) {
  return {
    x: { step: size, offset: 0 },
    y: { step: size, offset: 0 },
  };
}

export const composeBoaGrid = () => {
  const sizes = {};
  sizes[constants.DRAG_MODE.INSERT] = uniformGrid(10);
  sizes[constants.DRAG_MODE.FLOAT] = {
    x: { step: 200, offset: 0, activationDistance: 1250 },
    y: { step: 100, offset: constants.SKIRT_HEIGHT },
  };
  sizes[constants.DRAG_MODE.MIXED] = uniformGrid(10);
  return sizes;
};
